// Modules per gezin (0029_modules, verzoek oprichter 2026-09-25; docs/DESIGN.md §8.M). Het scherm
// Instellingen · Modules, de melding als een onderdeel uit staat, en brengen en halen in de agenda.
// Namen en uitleg per module staan in het register (packages/domain/src/modules/registry.ts).
// Toon: je-vorm, korte zinnen, werkwoorden op knoppen.
export const appModulesNl = {
    title: 'Modules',
    intro: 'Kies welke onderdelen jullie gebruiken. Uitzetten wist niets: zet je iets weer aan, dan staat alles er nog.',
    settingsBody: 'Zet onderdelen aan of uit, zoals brengen en halen',
    on: 'Aan',
    off: 'Uit',
    /** Rij: "Werkt samen met Locatie en weer." */
    dependsOn: 'Werkt alleen als {names} aan staat.',
    /** Rij die zelf aan staat maar door een andere module uit is. */
    blockedBy: 'Staat uit omdat {names} uit staat.',
    /** Schakelaar van een module die uit staat door een andere module (keuze blijft bewaard). */
    offBecause: 'Uit ({names} staat uit)',
    /** Voorbeeldnamen als het gezin (nog) geen twee volwassenen heeft. */
    exampleA: 'Sanne',
    exampleB: 'Daan',
    /** Alleen bij de islamitische set (Bijzondere dagen). */
    holidaysIslamic: 'Ook Suikerfeest en Offerfeest volgens jullie traditie.',
    /** Bij uitzetten: wat er mee uitgaat. */
    alsoOff: 'Daarmee gaat ook {names} uit.',
    notInPlan: 'Zit niet in jullie abonnement.',
    settings: 'Instellingen',
    /** WP3: toegankelijke naam van het tandwiel bij een module. */
    settingsOf: 'Instellingen van {name}',
    // Golf 6b (0043): modules die niet bij de soort huishouden passen, en de soort zelf.
    showAll: 'Alle modules tonen',
    showFewer: 'Alleen wat bij ons past',
    hiddenNote: 'Onderdelen die niet bij jullie soort huishouden passen, staan verborgen.',
    typeLine: 'Soort huishouden: {name}',
    typeChange: 'Wijzigen',
    toastOn: '{name} staat aan',
    toastOff: '{name} staat uit. Er is niets gewist.',
    toastOption: 'Opgeslagen',
    optionNeeds: 'Werkt als {name} aan staat.',
    onlyParents: 'Alleen een ouder kan dit veranderen.',
    kioskNote: 'De tablet past zich binnen een paar seconden aan.',
    // UX-ronde 2: groepen, zoeken en keuzes per module.
    groups: {
        agenda: 'Agenda en onderweg',
        home: 'Thuis en samen',
        personal: 'Persoonlijk',
        faith: 'Geloof en traditie',
        board: 'Bord en app',
        care: 'Zorg en familie',
    },
    groupCount: '{on} van {total} aan',
    search: 'Zoek een module',
    searchNone: 'Geen module gevonden voor "{q}".',
    options: 'Keuzes ({n})',
    // ---- Een scherm van een module die uit staat ------------------------------------------------
    offTitle: '{name} staat uit',
    offBody: 'Dit onderdeel staat uit voor jullie gezin. Er is niets gewist.',
    offBodyChild: 'Dit onderdeel staat uit. Vraag een ouder om het aan te zetten.',
    offAction: 'Naar Modules',
    // ---- Brengen en halen in de agenda ------------------------------------------------------------
    rides: {
        dropoff: '{name} brengt',
        pickup: '{name} haalt',
        both: '{name} brengt en haalt',
        whoDropoff: 'Wie brengt?',
        whoPickup: 'Wie haalt?',
        /** Smal blokje vóór de afspraak in dag en week. */
        travel: '{minutes} min onderweg',
        travelWho: '{name} rijdt · {minutes} min',
        /** 0056: smal blokje ná de afspraak (de weg terug). */
        travelBack: '{minutes} min terug',
    },
};
//# sourceMappingURL=modulesApp.nl.js.map